module.exports = __webpack_public_path__ + "img/art_6_4.9532043e.png";